import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ChevronDownIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full flex flex-col items-center pt-32 md:pt-40 pb-52 md:pb-64 lg:pb-72" data-id="element-110">
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=1920&q=80")',
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    }} data-id="element-111" />
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-black/50 via-black/40 to-black/70 backdrop-blur-[2px]" data-id="element-112" />

      {/* Main Content */}
      <div className="relative z-20 text-center px-6 flex flex-col items-center flex-1 justify-center max-w-4xl mx-auto" data-id="element-113">
        {/* Trust Badge */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-5 py-2 mb-5" data-id="element-114">
          <div className="flex gap-0.5" data-id="element-115">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5" style={{
            fill: '#FBBC04',
            color: '#FBBC04'
          }} strokeWidth={0} data-id="element-116" />)}
          </div>
          <span className="text-white/90 text-xs font-medium tracking-wide" data-id="element-117">
            #1 Rated Venue · Washington State
          </span>
        </motion.div>

        {/* Heading */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.4
      }} className="font-serif text-6xl md:text-8xl lg:text-9xl text-white mb-4 tracking-wide drop-shadow-lg" data-id="element-118">
          Copper Crest
        </motion.h1>

        {/* Tagline */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.6
      }} className="font-sans text-sm md:text-base text-white/90 font-light tracking-[0.25em] uppercase mb-6" data-id="element-119">
          Where Timeless Moments Begin
        </motion.p>

        {/* Description */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.8
      }} className="font-sans text-base md:text-lg text-white/85 font-light leading-relaxed max-w-xl mb-10" data-id="element-120">
          A premier estate nestled in Washington State, offering breathtaking
          venues for weddings, celebrations, and unforgettable gatherings since
          1923.
        </motion.p>

        {/* CTA Buttons */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 1
      }} className="flex flex-col sm:flex-row items-center gap-4" data-id="element-121">
          <a href="#contact" className="px-8 py-4 bg-copper text-white text-xs tracking-widest uppercase hover:bg-copper-dark transition-colors duration-300 w-full sm:w-auto text-center" data-id="element-122">
            Schedule a Tour
          </a>
          <a href="#spaces" className="px-8 py-4 border border-white/50 text-white text-xs tracking-widest uppercase hover:bg-white/10 transition-colors duration-300 w-full sm:w-auto text-center" data-id="element-123">
            View Our Spaces
          </a>
        </motion.div>
      </div>

      {/* Bottom Trust Strip */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 1.4
    }} className="relative z-20 w-full mt-12 md:mt-16 pb-8" data-id="element-124">
        <div className="flex items-center justify-center gap-6 md:gap-10 flex-wrap px-6" data-id="element-125">
          {/* Google */}
          <div className="flex items-center gap-2" data-id="element-126">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" data-id="element-127">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4" data-id="element-128" />
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-129" />
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18A10.96 10.96 0 0 0 1 12c0 1.77.42 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05" data-id="element-130" />
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-131" />
            </svg>
            <span className="text-white/90 text-xs font-medium" data-id="element-132">4.9</span>
            <div className="flex gap-0.5" data-id="element-133">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-2.5 h-2.5" style={{
              fill: '#FBBC04',
              color: '#FBBC04'
            }} strokeWidth={0} data-id="element-134" />)}
            </div>
          </div>

          <div className="w-[1px] h-4 bg-white/20 hidden md:block" data-id="element-135" />

          {/* The Knot */}
          <div className="flex items-center gap-2" data-id="element-136">
            <span className="font-serif text-xs font-bold" style={{
            color: '#E8554E'
          }} data-id="element-137">
              The Knot
            </span>
            <span className="text-white/80 text-[10px] tracking-wide uppercase" data-id="element-138">
              Best of 2024
            </span>
          </div>

          <div className="w-[1px] h-4 bg-white/20 hidden md:block" data-id="element-139" />

          {/* WeddingWire */}
          <div className="flex items-center gap-2" data-id="element-140">
            <span className="font-sans text-xs font-bold" style={{
            color: '#00B2A9'
          }} data-id="element-141">
              WeddingWire
            </span>
            <span className="text-white/80 text-[10px] tracking-wide uppercase" data-id="element-142">
              Couples' Choice
            </span>
          </div>
        </div>
      </motion.div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 1.8
    }} className="relative z-20 pb-2" data-id="element-143">
        <motion.div animate={{
        y: [0, 8, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} data-id="element-144">
          <ChevronDownIcon className="w-5 h-5 text-white/40" data-id="element-145" />
        </motion.div>
      </motion.div>
    </section>;
}